.section {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
}

.title {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
}

.buttons {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.hint {
  color: var(--color-texts-medium-contrast);
  font-size: 1.2rem;
}

.warning {
  color: var(--color-warning);
  font-size: 1.2rem;
}
